export function isMobile(): boolean {
  return window.innerWidth < 768;
}